import { compact } from "lodash";
import removeHash from "./remove-hash";

// LEGACY SITE OLD URL PATTERM
// domain/#/[QUERY]
const legacy = ({ hash }) => removeHash(hash);

// STATIC SITE URL PATTERN
// *domain/news/[PAGE_ID]
// domain/news/[PAGE_ID]/article/[ARTICLE_SLUG]
// domain/about
// domain/terms
// domain/privacy
// *domain/credits
// *domain/contact
// domain/contact/subject
// domain/account
// domain/account/overview/[*]
// domain/account/subscription/[*]
// domain/account/plans
// domain/account/receipts
// domain/account/notifications
// domain/account/presale
//
// (*) ignored
const prerender = ({ pathname, search }) => {
  const params = compact(pathname.split("/"));
  // Extraer query params de search
  const query = {};
  if (search) {
    const searchParams = new URLSearchParams(search);
    searchParams.forEach((value, key) => {
      query[key] = value;
    });
  }

  // Home page [no pound sign]
  if (params.length === 0) return false;

  const display = params.shift();
  const view = params.shift();
  switch (display) {
    case "news":
      // The newspaper is now an external site in an iframe, and the path after
      // /news is its article slug — which this function has no business
      // rewriting. It used to normalise /news -> /news/1 and
      // /news/:page/:slug -> /news/:page/article?id=:slug; against a slug it
      // instead stripped the trailing slash and pushed, which put a junk
      // entry in the history on every article the reader opened and broke the
      // Back button. Those legacy URLs still resolve: tc-url.js maps them to
      // the paper's front page.
      return false;

    case "account":
      const screen = view === "presale" ? "tickets" : view;
      return screen ? `/${display}?screen=${screen}` : false;

    case "about":
      return false;

    case "contact":
      return false;

    case "terms":
    case "privacy":
      return false;

    default:
      return false;
  }
};

export default ({ history, location }) => {
  try {
    const translated =
      location.hash !== "" ? legacy(location) : prerender(location);
    if (translated) {
      history.push(translated);
      return true;
    }
    return false;
  } catch (error) {
    console.warn(error);
    return false;
  }
};
